//SET_FILTERS

export const setFilters = (payload =
    {
        beginDate : '',
        endDate   : '',
        version   : '',
        fullDump  : false
    }) => ({
    type : 'SET_FILTERS',
    payload
});

//SET_BEGIN_DATE_FILTER
export const setBeginDateFilter = (beginDate) => ({
    type : 'SET_BEGIN_DATE_FILTER',
    beginDate
});

//SET_END_DATE_FILTER
export const setEndDateFilter = (endDate) => ({
    type : 'SET_END_DATE_FILTER',
    endDate
});
//SET_FORMAT_VERSION_FILTER
export const setFormatVersionFilter = (version) => ({
    type : 'SET_FORMAT_VERSION_FILTER',
    version
});

//SET_FULL_DUMP
export const setFullDump = (fullDump) => ({
    type : 'SET_FULL_DUMP',
    fullDump
});


// WEBPACK FOOTER //
// ./src/Actions/filters.js